import { render } from "./ButtonGlobalSearch.vue?vue&type=template&id=d9ea5e34"
import script from "./ButtonGlobalSearch.vue?vue&type=script&lang=js"
export * from "./ButtonGlobalSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__